<template>
  <v-btn color="primary" @click="$emit('click')" :disabled="disabled" class="px-2">
    <v-icon>{{ icon }}</v-icon>
    <btn-title v-if="$vuetify.breakpoint.smAndUp">{{ title }}</btn-title>
  </v-btn>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "Редактировать" },
    icon: { type: String, default: "far fa-edit" },
    disabled: { type: Boolean, default: false },
  },
};
</script>
